import style from './workout-detail-action.module.scss'
import CheckIcon from '../../asset/image/workout-detail-action/check-icon.png'
import CheckedIcon from '../../asset/image/workout-detail-action/checked-icon.png'
import { Workout } from '../../dao/core-dao'
import { useCompletedWorkouts } from '../../hook/use-workouts'
import { MusicSvgIcon } from '../util/images'
import React, { useMemo } from 'react'
import { Col, Row } from 'react-bootstrap'

export type WorkoutDetailActionRefObject = {
  setWorkoutCompleted: () => void
}

export const WorkoutDetailAction = (props: { workout: Workout }): React.ReactElement => {
  const { workout } = props

  const { data: completedWorkouts = [] } = useCompletedWorkouts({
    workoutIds: [workout.id],
  })

  // TODO: Should be aware if completed workout is from programme or not
  const isCompletedWorkout = useMemo(() => completedWorkouts?.length > 0, [completedWorkouts])
  return (
    <Row className={style.container}>
      <Col>
        {!isCompletedWorkout ? (
          <img className={style.icons} src={CheckIcon} />
        ) : (
          <img className={style.icons} src={CheckedIcon} />
        )}
      </Col>
      {/* <Col>
          <AddToCalendarSvgIcon />
        </Col> */}
      {/*
       * Presence, not `!== null` (GH-919). This anchor used to render unconditionally, so a
       * workout with a blank `playlist_url` — 15 of 1038 on dev, and zero nulls — showed a
       * live-looking music icon whose `href=""` resolves to the current page and reloads it.
       * Mobile's workout-details screen already gated on presence, so this file was the
       * outlier rather than the convention.
       *
       * ⚠️ The whole `<Col>` goes, not just the anchor — an empty column would still take a
       * bootstrap grid slot. The visible consequence: `.container` is a fixed 150×56 pill
       * (`border-radius: 2rem`), so on those workouts the completion icon sits in its left
       * half and the right half is empty grey. Left alone knowingly, same reasoning as the
       * popup — GH-907 is scoped to visibility, and resizing a shared pill is a styling
       * decision. If it reads badly, the fix is `.container`'s `max-width`, not putting the
       * dead anchor back.
       */}
      {props.workout.playlistUrl ? (
        <Col>
          <a href={props.workout.playlistUrl} target={'_blank'} rel="noreferrer">
            <MusicSvgIcon />
          </a>
        </Col>
      ) : null}
    </Row>
  )
}
